import * as React from 'react';
import { ScrollView } from 'react-native';
import GalanoGrotesqueText from '../../components/styled/GalanoGrotesqueText';
import View from '../../components/styled/View';
import styles from './styles';
import HeaderOne from '../../components/styled/HeaderOne';
import LinearGradientButton from '../../components/styled/LinearGradientButton';
import Logo from '../../components/styled/Logo';

export default function TermsOfServiceScreen({ navigation }) {
  return (
    <ScrollView style={styles.baseContainer}>
      <View style={styles.logoContainer}>
        <Logo logoOnly />
      </View>
      <View style={styles.sectionContainer}>
        <HeaderOne title="Terms of Service" />
        <View style={styles.paragraphContainer}>
          <GalanoGrotesqueText style={styles.tosText}>
            Welcome to{' '}
            <View style={styles.superscriptContainer}>
              <GalanoGrotesqueText style={styles.tosBoldText}>
                ToneBirds
              </GalanoGrotesqueText>
              <GalanoGrotesqueText style={styles.superscript}>
                TM
              </GalanoGrotesqueText>
            </View>{' '}
            - a website, web and mobile application, and service (collectively
            the "
            <GalanoGrotesqueText style={styles.tosBoldText}>
              Platform
            </GalanoGrotesqueText>
            ") provided by ToneBirds, LLC. ("
            <GalanoGrotesqueText style={styles.tosBoldText}>
              ToneBirds
            </GalanoGrotesqueText>
            ").
          </GalanoGrotesqueText>
        </View>
        <View style={styles.paragraphContainer}>
          <GalanoGrotesqueText style={styles.tosText}>
            Before you can listen to recording(s) and/or composition(s) made
            available on the Platform ("
            <GalanoGrotesqueText style={styles.tosBoldText}>
              Songs
            </GalanoGrotesqueText>
            ") you must agree to our terms of use.
          </GalanoGrotesqueText>
        </View>
        <View style={styles.paragraphContainer}>
          <GalanoGrotesqueText style={styles.tosText}>
            Once you have agreed to our terms of use, you will be able to:
          </GalanoGrotesqueText>
        </View>
        <View style={styles.subParagraphContainer}>
          <GalanoGrotesqueText style={styles.tosText}>
            Create a User Profile on the ToneBirds Platform and listen to Songs
            from your linked music service account, leave feedback on the songs,
            save interactions to your ToneBirds User Profile, and other
            activities.
          </GalanoGrotesqueText>
        </View>
      </View>
      <View style={styles.sectionContainer}>
        <GalanoGrotesqueText style={styles.tosSectionText}>
          Restrictions{' '}
        </GalanoGrotesqueText>
        <View style={styles.paragraphContainer}>
          <GalanoGrotesqueText style={styles.tosText}>
            You may not make any use of any Sons outside of the Platform,
            including without limitation, you may not do any of the following:
          </GalanoGrotesqueText>
        </View>
        <View style={styles.subParagraphContainer}>
          <GalanoGrotesqueText style={styles.tosText}>
            - Release for broadcast {'\n'}- Publish to the general public
            outside the ToneBirds platform {'\n'}- Release, sell or giveSongs to
            anyone else {'\n'}- Release for sale in any format (no commercial
            use) {'\n'}- Use ToneBirds to Infringe anyone’s copyright
          </GalanoGrotesqueText>
        </View>
      </View>
      <View style={styles.sectionContainer}>
        <GalanoGrotesqueText style={styles.tosSectionText}>
          Important{' '}
        </GalanoGrotesqueText>
        <View style={styles.paragraphContainer}>
          <GalanoGrotesqueText style={styles.tosText}>
            THIS TONEBIRDS END USER LICENSE AGREEMENT IS A LEGAL AGREEMENT
            BETWEEN YOU AND TONEBIRDS. READ IT CAREFULLY BEFORE CREATING AN
            ACCOUNT. THIS AGREEMENT GRANTS YOU A LICENSE TO USE THE TONEBIRDS
            PLATFORM AND CONTAINS WARRANTY INFORMATION AND LIABILITY
            DISCLAIMERS. BY CREATING AN ACCOUNT AND/OR USING THE TONEBIRDS
            PLATFORM, YOU ARE CONFIRMING YOUR ACCEPTANCE THE TERMS OF THIS
            AGREEMENT.{'\n'}
            Effective date: As of the date you create a user profile.{'\n'}
            All music on the ToneBirds platform shall remain at all times the
            property and copyright of the original recording artist(s) and
            content owner(s) ("
            <GalanoGrotesqueText style={styles.tosBoldText}>
              Original Artist
            </GalanoGrotesqueText>
            "), their Licensors and/or the relevant music publishers.{'\n'}
            The music made available to you for personal use only and only
            within the Platform and subject to these terms of use.
          </GalanoGrotesqueText>
        </View>
        <View style={styles.subParagraphContainer}>
          <GalanoGrotesqueText style={styles.tosText}>
            No rights are granted to make the available music to the general
            public either for general use or for commercial purposes.
          </GalanoGrotesqueText>
        </View>
        <View style={styles.subParagraphContainer}>
          <GalanoGrotesqueText style={styles.tosText}>
            You hereby warrant that you will not make the music on ToneBirds
            available to the public outside the ToneBirds Platform.
          </GalanoGrotesqueText>
        </View>
        <View style={styles.subParagraphContainer}>
          <GalanoGrotesqueText style={styles.tosText}>
            You agree to indemnify ToneBirds against any third party costs paid
            by ToneBirds pursuant to a third party claim which arises as a
            direct result of a breach by you of the foregoing warranties or
            representations.
          </GalanoGrotesqueText>
        </View>
        <View style={styles.subParagraphContainer}>
          <GalanoGrotesqueText style={styles.tosText}>
            Subject only to rights herein above granted to you, all rights of
            every kind and nature are reserved to the Original Artist together
            with all rights of use thereof.
          </GalanoGrotesqueText>
        </View>
        <View style={styles.subParagraphContainer}>
          <GalanoGrotesqueText style={styles.tosText}>
            You warrant that you will not infringe anyone's Intellectual
            Property Rights by using the ToneBirds Platform.
          </GalanoGrotesqueText>
        </View>
        <View style={styles.subParagraphContainer}>
          <GalanoGrotesqueText style={styles.tosText}>
            You warrant that you have contractual capacity and are not precluded
            from entering into this agreement.
          </GalanoGrotesqueText>
        </View>
        <View style={styles.subParagraphContainer}>
          <GalanoGrotesqueText style={styles.tosText}>
            We may from time to time vary any of these Terms and Conditions for
            any valid reason. We will notify members of any variation in writing
            by placing a notice on the website 7 days prior to the variation
            being effective.
          </GalanoGrotesqueText>
        </View>
        <View style={styles.subParagraphContainer}>
          <GalanoGrotesqueText style={styles.tosText}>
            This agreement shall be governed by and interpreted in accordance
            with the laws of the State of Washington, the courts of which shall
            be courts of competent jurisdiction.
          </GalanoGrotesqueText>
        </View>
        <View style={styles.subParagraphContainer}>
          <GalanoGrotesqueText style={styles.tosText}>
            We reserve the right to refuse or remove user profiles, files,
            comments, and/or content of any kind at any time in our sole
            discretion.
          </GalanoGrotesqueText>
        </View>
      </View>
      <View style={styles.sectionContainer}>
        <GalanoGrotesqueText style={styles.tosSectionText}>
          Copyright methods and notifications
        </GalanoGrotesqueText>
        <View style={styles.paragraphContainer}>
          <GalanoGrotesqueText style={styles.tosText}>
            We care about ensuring that artists and copyright owners have the
            tools they need to control how their work appears on ToneBirds.
            Reading further you will understand more about the tools we have in
            place today — both automated and manual — and how we are using these
            to look out for the rights of creators.
          </GalanoGrotesqueText>
        </View>
      </View>
      <View style={styles.sectionContainer}>
        <GalanoGrotesqueText style={styles.tosSectionText}>
          Manual takedowns on ToneBirds
        </GalanoGrotesqueText>
        <View style={styles.paragraphContainer}>
          <GalanoGrotesqueText style={styles.tosText}>
            Manual takedowns happen when people submit a report directly via
            email. Anyone can report a copyright infringement if they are the
            relevant copyright owner or their authorized representative, and
            every report has the same result: the reported content is taken down
            from ToneBirds while the dispute is resolved. Please send takedown
            notifications to info@ToneBirds.com or via mail to PoBox 370
            Eastsound Wa 99245
          </GalanoGrotesqueText>
        </View>
      </View>
      <View style={styles.sectionContainer}>
        <GalanoGrotesqueText style={styles.tosSectionText}>
          Copyright warnings and terminations
        </GalanoGrotesqueText>
        <View style={styles.paragraphContainer}>
          <GalanoGrotesqueText style={styles.tosText}>
            If we receive a valid notification from a third party in accordance
            with our reporting processes or applicable law that any of your
            content infringes the copyright, we will take the respective content
            down and send you a written notification to your registered email
            address asking you to clarify your rights by filing a dispute. If
            you do not successfully dispute the takedown - that is if you did
            not dispute the takedown after 7 days or if your dispute has been
            rejected -, we will send you a copyright warning to this effect via
            email and you will collect a strike to your account. Any user that
            receives more than two of these warnings is liable to have their
            access to the platform terminated forthwith.
          </GalanoGrotesqueText>
        </View>
        <View style={styles.paragraphContainer}>
          <GalanoGrotesqueText style={styles.tosText}>
            Copyright owners are not able to terminate anyone’s account — only
            ToneBirds can do this, and we will do it if we receive repeated
            reports of infringement. Whether a copyright owner takes down
            content directly, or reports it to us for takedown, the result is
            the same: the content is taken down until the issue can be resolved.
          </GalanoGrotesqueText>
        </View>
        <View style={styles.paragraphContainer}>
          <GalanoGrotesqueText style={styles.tosText}>
            Important: ToneBirds has a zero tolerance policy when it comes to
            the unauthorized publication of unreleased music. We will also
            suspend or terminate any account found liable of sharing unreleased
            copyright protected material. We will also suspend or terminate your
            account without warning if ordered to do so by a court, and/or in
            other appropriate circumstances, as determined by ToneBirds at its
            discretion.
          </GalanoGrotesqueText>
        </View>
      </View>
      <View style={styles.buttonContainer}>
        <LinearGradientButton
          // style={styles.buttonStyle}
          title="Back"
          onPress={() => navigation.navigate('SignUp')}
        ></LinearGradientButton>
      </View>
    </ScrollView>
  );
}
